import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresListaRemunerados', {
    template: template,
    controller: NominasNominaColaboradoresListaRemuneradosComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      data: '<',
      filtro: '<',
      calculado: '<',
      editable: '<',
      onChange: '&',
    },
  })

function NominasNominaColaboradoresListaRemuneradosComponent($filter) {
  let $ctrl = this,
    filterBy = $filter('filter')

  $ctrl.$onChanges = $onChanges
  $ctrl.editar = editar
  $ctrl.editando = null
  $ctrl.eliminar = eliminar
  $ctrl.filtrar = filtrar
  $ctrl.paginar = paginar

  function $onChanges(changes) {
    if (changes.filtro || changes.data) {
      filtrar()
    }
  }

  function editar(item, data) {
    angular.extend(item, data)
    $ctrl.editando = null
    actualizar()
  }

  function eliminar(item) {
    if (item) {
      $ctrl.data.splice($ctrl.data.indexOf(item), 1)
      actualizar()
    }
  }

  function actualizar() {
    $ctrl.onChange({$event: {data: $ctrl.data}})
  }

  function filtrar() {
    $ctrl.paginados = []
    $ctrl.resultados = [].concat(filterBy($ctrl.data, $ctrl.filtro))
    $ctrl.ocultos = $ctrl.data.length - $ctrl.resultados.length
    paginar()
  }

  function paginar() {
    $ctrl.paginados = $ctrl.paginados.concat($ctrl.resultados.splice(0, 20))
    $ctrl.completado = $ctrl.resultados.length === 0
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/lista/remunerados/component.js